import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { parseShopifyHost } from '../utils/parseShopifyHost';
import {storeLimit} from "../store/slices/storeLimit";

const POLL_INTERVAL = 10 * 1000; // 10 seconds const MAX_DURATION = 60 * 1000; // 1 minute
const MAX_DURATION = 60 * 1000; // 1 minute

export const useStoreLimitPolling = (clientConfig) => {
  const dispatch = useDispatch();
  const { isShopifyApp, shopName } = parseShopifyHost();
  const getSubscriptionStatus = useSelector(state => state.storeLimit?.planStatus);
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  const stopPolling = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  };

  useEffect(() => {
    if (getSubscriptionStatus !== 'pending') return;

    dispatch(storeLimit(shopName));

    intervalRef.current = setInterval(() => {
      dispatch(storeLimit(shopName));
    }, POLL_INTERVAL);

    timeoutRef.current = setTimeout(() => {
      stopPolling();
    }, MAX_DURATION);

    return () => stopPolling();
  }, [getSubscriptionStatus]);

  useEffect(() => {
    if (getSubscriptionStatus === 'completed' || getSubscriptionStatus === 'cancelled') {
      stopPolling();
    }
  }, [getSubscriptionStatus]);

  // ✅ return the status so component can use it
  return { getSubscriptionStatus };
};